/** Browser (Vite): the wasm as base64 in a JS module (build.sh), compiled synchronously, so the facade's sync API
 * needs no top-level await (Vite's default build target has none); sync compile is allowed below 8 MB. */
import base64 from './wasm/crdt_wasm_inline.js'
import { initSync } from './wasm/crdt_wasm.js'

initSync({ module: Uint8Array.from(atob(base64), char => char.charCodeAt(0)) })
